var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan__size width__scroll scroll_X_Y floor-brightness"},[_c('div',{attrs:{"id":"layout-canvas"}},[_c('img',{attrs:{"id":"imageUrl","src":_vm.imageUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }